import { Collapsible } from "@/components/ui";
import { TableBody } from "@/components/ui/Table";
import { Table, TableHead, TableHeader, TableRow } from "@/components/ui/Table";
import { HeaderText } from "@/components/ui/Text/HeaderText";
import { useDxReportOrderAOE } from "../../network/useDxReportOrderAOE";
import { AOEQuestionnaire } from "./AOEQuestionnaire";

export const AOEQuestionnaires = ({
  patientId,
  requestGroupId,
}: {
  patientId: string;
  requestGroupId: string;
}) => {
  const { data: orderAOE } = useDxReportOrderAOE({
    patientId,
    requestGroupId,
  });

  if (!orderAOE || !orderAOE?.testQuestionnairesResponses?.length) {
    return null;
  }

  return (
    <Collapsible title="Ask At Order Entry" open={true}>
      <Table condensed className="w-full table-fixed">
        <TableHeader>
          <TableRow>
            {["Question", "Answer"].map((title) => (
              <TableHead key={title}>
                <HeaderText size="md">{title}</HeaderText>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {orderAOE.testQuestionnairesResponses.map((questionnaireResponse) => (
            <AOEQuestionnaire
              key={questionnaireResponse.serviceRequestId}
              questionnaireResponse={questionnaireResponse}
            />
          ))}
        </TableBody>
      </Table>
    </Collapsible>
  );
};
